<template>
<div class="page">
  <div class="container">
    <div class="row">
      <div class="col s12 right-align">
        <p class="text-user">Hello {{user.username}} | <a @click="handleLogout" title="Logout" href="#">Logout</a></p>
      </div>
    </div>
    <div class="row center-box">
      <div class="col s12 box-content">
        <h1 class="heading1">
          {{contentpage.name}}
        </h1>
        <div v-html="contentpage.content"></div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'
import router from '../router'
import config from "../config.js"

export default {
  name: 'page',
  data() {
    return {
      user: [],
      usercookie: $cookies.get('arch-it-portal'),
      contentpage: []
    }
  },
  methods: {
    getuser: function() {
      var notif
      let params = new URLSearchParams();
      params.append('user', this.usercookie);      axios({
        method: 'post',
        url: config.getApiUrl('get-user'),
        data: params
      }).then(response => (this.user = response.data, this.loginstatus(response.data.message)));
    },
    loginstatus: function(e) {
      if (e != 'Success') {
        //console.log(e);
        router.push({
          name: 'Login'
        })
      } else {
        console.log(e);
      }
    },
    handleLogout: function() {
      $cookies.remove('arch-it-portal')
      router.push({
        name: 'Login'
      })
    },    getPage: function() {
      axios
        .get(config.getApiUrl('get-page/' + this.$route.params.name))
        .then(response => (this.contentpage = response.data, this.loginstatus(response.data.message)))
    },
  },
  beforeCreate() {
    var checkcookie = $cookies.get('arch-it-portal')
    if (checkcookie == null) {
      //console.log('kosong');
      router.push({
        name: 'Login'
      })
    } else {
      //console.log('login');
    }
  },
  created() {
    this.getuser()
    this.getPage()
  }
}
</script>

<style>
.box-content {
  background: #fff;
  color: #000;
  font-size: 14px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  padding: 20px;
}

.box-title {
  font-size: 2.0em;
}

h1 {
  color: #00205b;
  font-size: 3.0em;
  text-align: center;
}

.heading1 {
  font-size: 2.2em;
  margin-top: 25px;
}

@media (max-width:768px) {
  .center-box {
    margin-top: 30px !important;
  }

  .box-title {
    font-size: 17px;
  }

  .box-sm {
    padding-left: 25px;
    padding-right: 25px;
  }
}

.icon-size {
  font-size: 5.0em;
}

.text-copy {
  font-size: 12px;
  color: #000;
  text-align: center;
}
.text-user { margin-top:60px;}
.text-user,
.text-user a,
.text-user a:hover {
  color: #fff;
  text-decoration: none;
}

.table tr:nth-child(odd) {
  background-color: #f2f2f2;
}

.table tr:nth-child(even) {
  background-color: #ffffff;
}

@media (max-width:768px) {
  .text-user {
    margin-top: 50px;
  }

  h1 {
    margin: 0.1rem 0 1.68rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page.vue